import { getSignature } from '@/utils/http/methods/getSignature';
import { getParams, isAdminMode } from '@/utils/params';
import { getRequest } from './methods/getRequest';
import { postRequest } from './methods/postRequest';
import { requestToJSON } from './methods/requestToJSON';
import { Params, addParamsToUrl } from './methods/urlParams';

export const getUrl = (url: string) => `/api/v1/${url}`;

const addMediaTypeAndLocaleToParams = (params: Params = {}) => {
  params.mediaType = 'json';
  params.locale = getParams().locale;
  return params;
};

export const fetchFromApi = <ResponseType>(
  url: string,
  params?: Record<string, any>,
  init?: RequestInit
) =>
  requestToJSON<ResponseType>(
    getRequest(addParamsToUrl(getUrl(url), addMediaTypeAndLocaleToParams(params)), init)
  );

const signParams = async (url: string, params: Record<string, any> = {}, method: string) => {
  const time = new Date().getTime();
  const sig = await getSignature(`${method} ${getUrl(url)} ${time} ${getParams().secret}`);

  return Object.assign(params, {
    apiKey: getParams().apiKey,
    time,
    sig,
  });
};

export const fetchFromApiSigned = <ResponseType>(
  url: string,
  params?: Record<string, any>,
  init?: RequestInit
) =>
  signParams(url, params, 'GET').then((signedParams) =>
    fetchFromApi<ResponseType>(url, signedParams, init)
  );

export const postToApiSigned = <ResponseType>(
  url: string,
  data: unknown,
  params?: Record<string, any>,
  signal?: AbortSignal
) =>
  requestToJSON<ResponseType>(
    signParams(url, params, 'POST').then((signedParams) =>
      postRequest(addParamsToUrl(getUrl(url), addMediaTypeAndLocaleToParams(signedParams)), data, {
        signal,
      })
    )
  );

export const fetchFromApiSignedIfAdmin = <ResponseType>(
  url: string,
  params?: Record<string, any>,
  init?: RequestInit
) =>
  isAdminMode()
    ? fetchFromApiSigned<ResponseType>(url, params, init)
    : fetchFromApi<ResponseType>(url, params, init);
